import { Typography, Box, Link } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const FAQ = (props) => {
  return (
    <Box sx={{ width: { xs: '90%', sm: '80%' }, mx: 'auto', mt: '6rem' }}>
      <Typography variant='h5' component='h2' sx={{ fontWeight: 'bold', mb: '2rem' }}>
        FAQ
      </Typography>
      <div>
        <Accordion sx={{ boxShadow: '0px 5px 25px rgba(0,0,0,0.15)' }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls='panel1a-content' id='panel1a-header'>
            <Typography sx={{ fontWeight: 'bold' }}>What is The 100 Club?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>The 100 Club is a private mastermind community for founders in Singapore.</Typography>
            <Typography sx={{ mt: '1.5rem' }}>
              Members of The 100 Club run growing businesses in Singapore, across a wide array of industries. Some are
              bootstrapped, others venture-backed. But all our members seek belonging, support, and connection with a
              selective group of their peers.
            </Typography>
            <Typography sx={{ mt: '1.5rem' }}>
              Members who join us get matched into a mastermind group of 8 founders with an executive facilitator, that
              meets every month to discuss business challenges. Additionally, they can expect to be part of a digital
              community, an in-person community, have access to speakers, and a membership card to claim perks
              throughout Singapore.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion sx={{ boxShadow: '0px 5px 25px rgba(0,0,0,0.15)' }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls='panel1a-content' id='panel1a-header'>
            <Typography sx={{ fontWeight: 'bold' }}>What are the requirements for The 100 Club membership?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              The 100 Club is currently only accepting applications for founders of businesses. Our members range from
              venture-backed deep-tech startups to bootstrapped SMEs, and everything in between. We house both founders
              who are getting started in their journey as well as founders who have exited companies and are working on
              their new ventures. We favour friendly founders who are keen to contribute to others.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion sx={{ boxShadow: '0px 5px 25px rgba(0,0,0,0.15)' }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls='panel2a-content' id='panel2a-header'>
            <Typography sx={{ fontWeight: 'bold' }}>How can I join?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Anyone can feel free to apply through <Link href='/payments'>this application</Link>.
            </Typography>
            <Typography sx={{ mt: '1.5rem' }}>
              If you meet the minimum criteria for The 100 Club membership, you’ll be asked to schedule a 30 minute chat
              with someone from our membership team. They’ll conduct the interview and share the information with the
              rest of our team. We will let you know about your application status within 24 hours.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion sx={{ boxShadow: '0px 5px 25px rgba(0,0,0,0.15)' }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls='panel2a-content' id='panel2a-header'>
            <Typography sx={{ fontWeight: 'bold' }}>What is included in The 100 Club membership?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>The 100 Club has 5 core pillars through which we view our member benefits:</Typography>
            <Typography sx={{ mt: '1.5rem' }}>
              <span style={{ fontWeight: 'bold' }}>1. Mastermind Group:</span> The 100 Club mastermind groups consist of
              8 founders and an executive facilitator who meet 9-10 times per year for ~2 hours each time. Mastermind
              groups are a structured way to develop real relationships with founders in similar situations in order to
              connect, share, and get invaluable business feedback and advice.
            </Typography>

            <Typography sx={{ mt: '1.5rem' }}>
              <span style={{ fontWeight: 'bold' }}>2. Digital Community:</span> We pride ourselves on having the most
              active and engaged founder-based community in Singapore. We also have sub-groups, a weekly newsletter,
              member directory, and a community manager available to help you connect and maximize your experience.
            </Typography>
            <Typography sx={{ mt: '1.5rem' }}>
              <span style={{ fontWeight: 'bold' }}>3. In-person Community:</span> The 100 Club members love being
              together. That’s why we have our famous monthly modern networking events, which are planned and organised
              by The 100 Club. We’re planning annual retreats, available to all members, that aim to bring both personal
              and professional development to a unique, modern, and luxurious setting. Lastly, we have The 100 Club
              teh peng chat, where we match you with another member for a 1:1 teh peng chat.
            </Typography>
            <Typography sx={{ mt: '1.5rem' }}>
              <span style={{ fontWeight: 'bold' }}>4. Education:</span> Our speaker series aims to bring in other
              founders and successful CEOs so you can continue learning from the best there is. We host workshops,
              speaker events, discussions, and more.
            </Typography>
            <Typography sx={{ mt: '1.5rem' }}>
              <span style={{ fontWeight: 'bold' }}>5. Exclusive Perks:</span> All members who join us get a smart
              100Card, which they can use at select locations throughout Singapore for exclusive discounts.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion sx={{ boxShadow: '0px 5px 25px rgba(0,0,0,0.15)' }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls='panel3a-content' id='panel3a-header'>
            <Typography sx={{ fontWeight: 'bold' }}>What is a mastermind group?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Monthly mastermind group meetings are the cornerstone of The 100 Club experience and is the only part of
              The 100 Club that is mandatory. When you join The 100 Club, our membership team will carefully handpick
              other members to join your group, and you’ll be curated into a group with seven other founders and an
              experienced, executive facilitator. Groups are created based first on industry, then on traction (revenue,
              growth, users, employees, etc).
            </Typography>
            <Typography sx={{ mt: '1.5rem' }}>
              Mastermind group meetings can be physical or virtual, lasts 2 hours and there are 9-10 per year.
            </Typography>
            <Typography sx={{ mt: '1.5rem' }}>
              You should think of your mastermind group as your own personal board of directors - there to give you
              advice, provide critical feedback, and help you accelerate the growth of your business.
            </Typography>
            <Typography sx={{ mt: '1.5rem' }}>
              Meetings are structured and organized by your facilitator, who uses a tested playbook that allows you to
              focus on the most important parts of your personal or professional life.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
    </Box>
  );
};

export default FAQ;
